const TURNSTILE_RETRY_DELAY_MS = 100;

export const renderTurnstileWhenReady = ({
  container,
  widgetIdRef,
  options
}) => {
  let canceled = false;
  let intervalId = null;

  const turnstileContainer = container;
  const turnstileWidgetIdRef = widgetIdRef;

  const cleanup = () => {
    canceled = true;

    if(intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    if(turnstileWidgetIdRef.current != null && window?.turnstile?.remove) {
      window.turnstile.remove(turnstileWidgetIdRef.current);
    }
  }

  const tryRender = () => {
    if(canceled) {
      return true;
    }

    const turnstile = window?.turnstile;

    if(!turnstileContainer || !turnstile?.render) {
      return false;
    }

    if(turnstileWidgetIdRef.current != null && turnstile?.remove) {
      turnstile.remove(turnstileWidgetIdRef.current);
    }

    turnstileContainer.innerHTML = '';

    turnstileWidgetIdRef.current = turnstile.render(
      turnstileContainer,
      options
    );

    return true;
  }

  if(tryRender()) {
    return cleanup;
  }

  intervalId = setInterval(() => {
    if(tryRender() && intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }, TURNSTILE_RETRY_DELAY_MS);

  return cleanup;
}

export const isTurnstileWidgetVisible = container => {
  const elements = container ? Array.from(container.children) : [];

  return elements.some(element => {
    const { width, height } = element.getBoundingClientRect();

    if(!width || !height) {
      return false;
    }

    if(typeof element.checkVisibility != 'function') {
      return true;
    }

    return element.checkVisibility({
      checkOpacity: true,
      checkVisibilityCSS: true
    });
  });
}